import { useState, useRef, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { zoomStyles as styles } from './court.tailwind';

const ZoomControls = ({
    handleReset,
    handleZoomIn,
    handleZoomOut,
    isZoomInDisabled,
    isZoomOutDisabled
}) => {
    const zoomIntervalRef = useRef(null);

    const [isAnimating, setIsAnimating] = useState(false);
    const [activeZoom, setActiveZoom] = useState(null); // 'in', 'out', or null
    // const lastZoomTimeRef = useRef(0);

    const startZoomIn = () => {
        if (!isZoomInDisabled && activeZoom === null) {
            setActiveZoom('in');
            handleZoomIn();
            zoomIntervalRef.current = setInterval(() => {
                if (!isZoomInDisabled) {
                    handleZoomIn();
                } else {
                    stopZooming();
                }
            }, 300);
        }
    };

    const startZoomOut = () => {
        if (!isZoomOutDisabled && activeZoom === null) {
            setActiveZoom('out');
            handleZoomOut();
            zoomIntervalRef.current = setInterval(() => {
                if (!isZoomOutDisabled) {
                    handleZoomOut();
                } else {
                    stopZooming();
                }
            }, 320);
        }
    };

    // const startZoomIn = () => {
    //     const now = Date.now();
    //     if (!isZoomInDisabled && activeZoom === null && now - lastZoomTimeRef.current > 50) {
    //         lastZoomTimeRef.current = now;
    //         setActiveZoom('in');
    //         handleZoomIn();
            
    //         // Add a small delay before starting continuous zoom
    //         setTimeout(() => {
    //             if (activeZoom === 'in') {  // Only start interval if still zooming
    //                 zoomIntervalRef.current = setInterval(() => {
    //                     if (!isZoomInDisabled) {
    //                         handleZoomIn();
    //                     } else {
    //                         stopZooming();
    //                     }
    //                 }, 100);
    //             }
    //         }, 250);
    //     }
    // };

    // const startZoomOut = () => {
    //     const now = Date.now();
    //     if (!isZoomOutDisabled && activeZoom === null && now - lastZoomTimeRef.current > 100) {
    //         lastZoomTimeRef.current = now;
    //         setActiveZoom('out');
    //         handleZoomOut();
            
    //         // Add a small delay before starting continuous zoom
    //         setTimeout(() => {
    //             if (activeZoom === 'out') {  // Only start interval if still zooming
    //                 zoomIntervalRef.current = setInterval(() => {
    //                     if (!isZoomOutDisabled) {
    //                         handleZoomOut();
    //                     } else {
    //                         stopZooming();
    //                     }
    //                 }, 100);
    //             }
    //         }, 250);
    //     }
    // };

    const stopZooming = () => {
        if (zoomIntervalRef.current) {
            clearInterval(zoomIntervalRef.current);
            zoomIntervalRef.current = null;
        }
        setActiveZoom(null);
    };

    const onReset = () => {
        stopZooming();
        setIsAnimating(true);
        handleReset();
        setTimeout(() => setIsAnimating(false), 500);
    };

    useEffect(() => {
        return () => {
            if (zoomIntervalRef.current) {
                clearInterval(zoomIntervalRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if ((activeZoom === 'in' && isZoomInDisabled) || 
            (activeZoom === 'out' && isZoomOutDisabled)) {
            stopZooming();
        }
    }, [isZoomInDisabled, isZoomOutDisabled, activeZoom]);

    return (
        <div className={styles.zoomContainer}>
            <div className={styles.zoomContols}>
                <div className={styles.buttonContainer}>
                    <button
                        className={`${styles.zoomEdit} ${styles.zoomIn}`}
                        onMouseDown={startZoomIn}
                        onMouseUp={stopZooming}
                        onMouseLeave={stopZooming}
                        onTouchStart={(e) => { e.preventDefault(); startZoomIn(); }}
                        onTouchEnd={(e) => { e.preventDefault(); stopZooming(); }}
                        disabled={isZoomInDisabled}>
                        <AddIcon sx={{ fontSize: '18px' }} />
                    </button>
                    <button
                        className={`${styles.zoomEdit} ${styles.zoomOut}`}
                        onMouseDown={startZoomOut}
                        onMouseUp={stopZooming}
                        onMouseLeave={stopZooming}
                        onTouchStart={(e) => { e.preventDefault(); startZoomOut(); }}
                        onTouchEnd={(e) => { e.preventDefault(); stopZooming(); }}
                        disabled={isZoomOutDisabled}>
                        <RemoveIcon sx={{ fontSize: '18px' }} />
                    </button>
                </div>
                <button
                    className={`${styles.resetButton} ${isAnimating ? 'animate-reset' : ''}`}
                    aria-label="Reset View"
                    onClick={onReset}>
                    <svg
                        fill="#ffffff"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 32 32"
                        height="20px"
                        stroke="#ffffff"
                        strokeWidth="1 "
                    >
                        <g id="reset">
                            <path
                                id="reset_1_"
                                d="M16,31.36C7.53,31.36,0.64,24.47,0.64,16S7.53,0.64,16,0.64c4.529,0,8.717,1.932,11.64,5.336V1h0.721v6.36H22V6.64h5.259C24.466,3.275,20.402,1.36,16,1.36C7.927,1.36,1.36,7.927,1.36,16c0,8.072,6.567,14.64,14.64,14.64c8.072,0,14.64-6.567,14.64-14.64h0.721C31.36,24.47,24.47,31.36,16,31.36z"
                            />
                        </g>
                    </svg>
                </button>
            </div>
        </div>
    )
};

export default ZoomControls

// ? 'bg-gray-700 text-gray-500 cursor-not-allowed' 